import { IRRIGATION_SCHEDULER_FIRST_DAY_OF_WEEK } from '@semios/app-platform-values-helpers-and-types'
import moment from 'moment-timezone'

export const snapToWeekStart = (m: moment.Moment): moment.Moment =>
  m.clone().subtract((m.day() - IRRIGATION_SCHEDULER_FIRST_DAY_OF_WEEK + 7) % 7, 'days')

export const snapToWeekEnd = (m: moment.Moment): moment.Moment => snapToWeekStart(m).add(6, 'days')

export const snapForwardToWeekStart = (m: moment.Moment): moment.Moment => {
  const weekStart = snapToWeekStart(m)

  return weekStart.isSame(m, 'day') ? weekStart : weekStart.add(7, 'days')
}

export const snapBackwardToWeekEnd = (m: moment.Moment): moment.Moment => {
  const weekEnd = snapToWeekEnd(m)

  return weekEnd.isSame(m, 'day') ? weekEnd : weekEnd.subtract(7, 'days')
}

export const getLastCompletedWeekEnd = (timezone: string): moment.Moment =>
  snapToWeekEnd(moment.tz(timezone)).subtract(7, 'days')
